// extracted by mini-css-extract-plugin
export default {"skeleton":"eSignCNWebContainer_skeleton__7zRDy","iframe":"eSignCNWebContainer_iframe__48Ze4"};